/** Shared Chart.js hover for AI Proficiency time-series line charts. */
export const TIME_SERIES_INTERACTION = {
  mode: 'nearest' as const,
  axis: 'x' as const,
  intersect: false,
};
